import React from "react";

const LeftAlignment = ({
	customComponent,
	onClick,
	isActive,
	isDisabled,
	isBulletList = false,
	isOrderedList = false,
	name,
	icon
}) => {
	const alignLeft = () => {
		if (onClick) onClick();
	};

	return (
		<>
			<button
				className={`editor-menu-item${
					isActive && !isBulletList && !isOrderedList ? " is-active" : ""
				}`}
				onClick={alignLeft}
				title={name || "Left Align"}
				type="button"
				disabled={isDisabled}
			>
				{customComponent ? customComponent : <i className={`fas ${icon}`} />}
			</button>
		</>
	);
};

export default LeftAlignment;
